import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState, useEffect } from "react";
import { subirDatosSingle } from './syncSupabase';
import { authHeader } from './supabase';

const STORAGE_KEY = 'alqos_cumplimiento';
const storage = {
  get: () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch { return {}; } },
  set: (v) => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch {} },
};

const NORMAS = {
  "ISO 9001:2015": {
    color: "#2A7FFF",
    secciones: [
      { id: "4", titulo: "4. Contexto de la organización", clausulas: [
        { id: "4.1", titulo: "Comprensión de la organización y su contexto" },
        { id: "4.2", titulo: "Comprensión de las necesidades de las partes interesadas" },
        { id: "4.3", titulo: "Alcance del SGC" },
        { id: "4.4", titulo: "Sistema de gestión de la calidad y sus procesos" },
      ]},
      { id: "5", titulo: "5. Liderazgo", clausulas: [
        { id: "5.1", titulo: "Liderazgo y compromiso" },
        { id: "5.2", titulo: "Política de calidad" },
        { id: "5.3", titulo: "Roles, responsabilidades y autoridades" },
      ]},
      { id: "6", titulo: "6. Planificación", clausulas: [
        { id: "6.1", titulo: "Acciones para abordar riesgos y oportunidades" },
        { id: "6.2", titulo: "Objetivos de calidad y planificación" },
        { id: "6.3", titulo: "Planificación de los cambios" },
      ]},
      { id: "7", titulo: "7. Apoyo", clausulas: [
        { id: "7.1", titulo: "Recursos" },
        { id: "7.2", titulo: "Competencia" },
        { id: "7.3", titulo: "Toma de conciencia" },
        { id: "7.4", titulo: "Comunicación" },
        { id: "7.5", titulo: "Información documentada" },
      ]},
      { id: "8", titulo: "8. Operación", clausulas: [
        { id: "8.1", titulo: "Planificación y control operacional" },
        { id: "8.2", titulo: "Requisitos para productos y servicios" },
        { id: "8.3", titulo: "Diseño y desarrollo" },
        { id: "8.4", titulo: "Control de procesos externos" },
        { id: "8.5", titulo: "Producción y provisión del servicio" },
        { id: "8.6", titulo: "Liberación de productos y servicios" },
        { id: "8.7", titulo: "Control de salidas no conformes" },
      ]},
      { id: "9", titulo: "9. Evaluación del desempeño", clausulas: [
        { id: "9.1", titulo: "Seguimiento, medición, análisis y evaluación" },
        { id: "9.2", titulo: "Auditoría interna" },
        { id: "9.3", titulo: "Revisión por la dirección" },
      ]},
      { id: "10", titulo: "10. Mejora", clausulas: [
        { id: "10.1", titulo: "Generalidades" },
        { id: "10.2", titulo: "No conformidades y acciones correctivas" },
        { id: "10.3", titulo: "Mejora continua" },
      ]},
    ]
  },
  "ISO 14001:2015": {
    color: "#22c55e",
    secciones: [
      { id: "4", titulo: "4. Contexto de la organización", clausulas: [
        { id: "4.1", titulo: "Comprensión de la organización y su contexto" },
        { id: "4.2", titulo: "Necesidades y expectativas de partes interesadas" },
        { id: "4.3", titulo: "Alcance del SGA" },
        { id: "4.4", titulo: "Sistema de gestión ambiental" },
      ]},
      { id: "5", titulo: "5. Liderazgo", clausulas: [
        { id: "5.1", titulo: "Liderazgo y compromiso" },
        { id: "5.2", titulo: "Política ambiental" },
        { id: "5.3", titulo: "Roles y responsabilidades" },
      ]},
      { id: "6", titulo: "6. Planificación", clausulas: [
        { id: "6.1", titulo: "Acciones para abordar riesgos — aspectos ambientales" },
        { id: "6.2", titulo: "Objetivos ambientales" },
      ]},
      { id: "7", titulo: "7. Apoyo", clausulas: [
        { id: "7.1", titulo: "Recursos" },
        { id: "7.2", titulo: "Competencia" },
        { id: "7.3", titulo: "Toma de conciencia" },
        { id: "7.4", titulo: "Comunicación" },
        { id: "7.5", titulo: "Información documentada" },
      ]},
      { id: "8", titulo: "8. Operación", clausulas: [
        { id: "8.1", titulo: "Planificación y control operacional" },
        { id: "8.2", titulo: "Preparación y respuesta ante emergencias" },
      ]},
      { id: "9", titulo: "9. Evaluación del desempeño", clausulas: [
        { id: "9.1", titulo: "Seguimiento, medición, análisis y evaluación" },
        { id: "9.2", titulo: "Auditoría interna" },
        { id: "9.3", titulo: "Revisión por la dirección" },
      ]},
      { id: "10", titulo: "10. Mejora", clausulas: [
        { id: "10.1", titulo: "Generalidades" },
        { id: "10.2", titulo: "No conformidades y acciones correctivas" },
        { id: "10.3", titulo: "Mejora continua" },
      ]},
    ]
  },
  "FSC CoC": {
    color: "#065f46",
    secciones: [
      { id: "1", titulo: "1. Sistema de gestión", clausulas: [
        { id: "1.1", titulo: "Política FSC y compromiso de la dirección" },
        { id: "1.2", titulo: "Responsable FSC designado" },
        { id: "1.3", titulo: "Procedimientos documentados" },
        { id: "1.4", titulo: "Capacitación del personal" },
        { id: "1.5", titulo: "Registros y trazabilidad" },
      ]},
      { id: "2", titulo: "2. Control de materiales", clausulas: [
        { id: "2.1", titulo: "Identificación de categorías de productos FSC" },
        { id: "2.2", titulo: "Balance de masa o transferencia de porcentaje" },
        { id: "2.3", titulo: "Control de proveedores FSC" },
        { id: "2.4", titulo: "Separación física o balance de masa" },
      ]},
      { id: "3", titulo: "3. Ventas y etiquetado", clausulas: [
        { id: "3.1", titulo: "Declaraciones de ventas FSC" },
        { id: "3.2", titulo: "Uso de la marca FSC" },
        { id: "3.3", titulo: "Facturas y documentos de venta" },
      ]},
    ]
  },
  "FSSC 22000": {
    color: "#92400e",
    secciones: [
      { id: "4", titulo: "4. Contexto", clausulas: [
        { id: "4.1", titulo: "Contexto de la organización" },
        { id: "4.2", titulo: "Partes interesadas" },
        { id: "4.3", titulo: "Alcance del SGSA" },
      ]},
      { id: "5", titulo: "5. Liderazgo", clausulas: [
        { id: "5.1", titulo: "Liderazgo y compromiso" },
        { id: "5.2", titulo: "Política de inocuidad" },
        { id: "5.3", titulo: "Roles y responsabilidades" },
      ]},
      { id: "6", titulo: "6. Planificación", clausulas: [
        { id: "6.1", titulo: "Riesgos y oportunidades" },
        { id: "6.2", titulo: "Objetivos del SGSA" },
      ]},
      { id: "7", titulo: "7. Apoyo", clausulas: [
        { id: "7.1", titulo: "Recursos — infraestructura y ambiente" },
        { id: "7.2", titulo: "Competencia" },
        { id: "7.5", titulo: "Información documentada" },
      ]},
      { id: "8", titulo: "8. Operación", clausulas: [
        { id: "8.1", titulo: "Planificación y control operacional" },
        { id: "8.2", titulo: "Programas de prerrequisitos (PPR)" },
        { id: "8.3", titulo: "Trazabilidad" },
        { id: "8.4", titulo: "Preparación y respuesta ante emergencias" },
        { id: "8.5", titulo: "Control de peligros — HACCP" },
        { id: "8.6", titulo: "Actualización del sistema HACCP" },
        { id: "8.7", titulo: "Control de seguimiento y medición" },
        { id: "8.8", titulo: "Verificación PPR y plan HACCP" },
        { id: "8.9", titulo: "Control de no conformidades" },
      ]},
      { id: "9", titulo: "9. Evaluación", clausulas: [
        { id: "9.1", titulo: "Seguimiento y medición" },
        { id: "9.2", titulo: "Auditoría interna" },
        { id: "9.3", titulo: "Revisión por la dirección" },
      ]},
      { id: "10", titulo: "10. Mejora", clausulas: [
        { id: "10.1", titulo: "No conformidades y acciones correctivas" },
        { id: "10.2", titulo: "Mejora continua" },
      ]},
    ]
  },
  "HACCP": {
    color: "#b91c1c",
    secciones: [
      { id: "1", titulo: "Principios HACCP — Codex Alimentarius", clausulas: [
        { id: "P1", titulo: "P1 — Análisis de peligros" },
        { id: "P2", titulo: "P2 — Identificación de PCC" },
        { id: "P3", titulo: "P3 — Límites críticos" },
        { id: "P4", titulo: "P4 — Sistema de vigilancia" },
        { id: "P5", titulo: "P5 — Medidas correctivas" },
        { id: "P6", titulo: "P6 — Procedimientos de verificación" },
        { id: "P7", titulo: "P7 — Documentación y registros" },
      ]},
    ]
  },
};

export default function CumplimientoNormas({ onVolver, oscuro, usuario }) {
  const [datos, setDatos] = useState({});
  const [cargando, setCargando] = useState(true);
  const [normaActiva, setNormaActiva] = useState("ISO 9001:2015");
  const [clausulaAbierta, setClausulaAbierta] = useState(null);
  const [cargandoARIA, setCargandoARIA] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    async function cargar() {
      try {
        const { supabase } = await import('./supabase');
        const { data } = await supabase.from('cumplimiento_normas').select('data');
        if (data && data.length > 0) {
          const obj = {};
          data.forEach(r => { obj[r.data.id] = r.data; });
          setDatos(obj);
        } else setDatos(storage.get());
      } catch { setDatos(storage.get()); }
      setCargando(false);
    }
    cargar();
  }, []);

  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: subtexto, fontWeight: "600", display: "block", marginTop: "12px" };

  const getEstado = (id) => datos[id]?.estado || "pendiente";
  const colorEstado = { cumple: "#22c55e", parcial: "#f59e0b", pendiente: "#e63946", noaplica: "#808085" };
  const labelEstado = { cumple: "✅ Cumple", parcial: "⚠️ Parcial", pendiente: "❌ Pendiente", noaplica: "— No aplica" };

  const norma = NORMAS[normaActiva];

  const calcPorcentaje = (normaKey) => {
    const n = NORMAS[normaKey];
    const total = n.secciones.reduce((a, s) => a + s.clausulas.length, 0);
    const cumple = n.secciones.reduce((a, s) => a + s.clausulas.filter(c => datos[`${normaKey}-${c.id}`]?.estado === "cumple").length, 0);
    const parcial = n.secciones.reduce((a, s) => a + s.clausulas.filter(c => datos[`${normaKey}-${c.id}`]?.estado === "parcial").length, 0);
    return Math.round(((cumple + parcial * 0.5) / total) * 100);
  };

  const guardarClausula = (normaKey, clausulaId) => {
    const key = `${normaKey}-${clausulaId}`;
    const nuevo = { ...datos, [key]: { ...form, id: key, norma: normaKey, clausula: clausulaId, fechaActualizacion: new Date().toISOString(), actualizadoPor: usuario?.nombre } };
    setDatos(nuevo);
    storage.set(nuevo);
    subirDatosSingle(STORAGE_KEY, 'cumplimiento');
    setClausulaAbierta(null);
    setForm({});
  };

  const analizarConARIA = async (normaKey, clausula) => {
    const key = `${normaKey}-${clausula.id}`;
    const evidencia = datos[key]?.evidencia || "";
    if (!evidencia) { alert("Cargá evidencia primero para que ARIA pueda analizarla."); return; }
    setCargandoARIA(true);
    try {
      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()),
          "Content-Type": "application/json",
          "anthropic-version": "2023-06-01",
          },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 1000,
          messages: [{
            role: "user",
            content: `Sos un auditor experto en ${normaKey}. Analizá si la siguiente evidencia cumple con el requisito "${clausula.id} — ${clausula.titulo}" de ${normaKey}.

Evidencia presentada: "${evidencia}"

Respondé SOLO en JSON sin markdown:
{
  "estado": "cumple" o "parcial" o "pendiente",
  "justificacion": "explicación en 2-3 oraciones",
  "brechas": ["brecha 1", "brecha 2"],
  "recomendaciones": ["acción 1", "acción 2"]
}`
          }]
        })
      });
      const data = await response.json();
      const raw = data.content?.[0]?.text || "";
      const resultado = JSON.parse(raw.replace(/```json|```/g, "").trim());
      setForm(f => ({ ...f, estado: resultado.estado, ariaJustificacion: resultado.justificacion, ariaBrechas: resultado.brechas, ariaRecomendaciones: resultado.recomendaciones }));
    } catch(e) { alert("Error con ARIA: " + e.message); }
    setCargandoARIA(false);
  };

  if (cargando) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background: bg }}>
      <p style={{ color: oscuro?"white":"#09184D" }}>Cargando...</p>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background: bg, fontFamily:"sans-serif" }}>
      {/* NAV */}
      <div style={{ background: navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>📋 Cumplimiento de Normas</span>
        </div>
        <BotonInstructivo moduloKey="cumplimiento" oscuro={oscuro} />
        {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="cumplimiento_normas" oscuro={oscuro} />}
      </div>

      {/* TABS NORMAS */}
      <div style={{ padding:"1rem 1.5rem 0", display:"flex", gap:"8px", flexWrap:"wrap" }}>
        {Object.keys(NORMAS).map(n => {
          const pct = calcPorcentaje(n);
          return (
            <button key={n} onClick={() => setNormaActiva(n)}
              style={{ padding:"8px 14px", borderRadius:"10px", fontSize:"12px", fontWeight:"600", cursor:"pointer", border: normaActiva===n ? `2px solid ${NORMAS[n].color}` : `1px solid ${borde}`, background: normaActiva===n ? `${NORMAS[n].color}22` : cardBg, color: normaActiva===n ? NORMAS[n].color : subtexto }}>
              {n} <span style={{ marginLeft:"4px", fontSize:"11px" }}>{pct}%</span>
            </button>
          );
        })}
      </div>

      {/* BARRA PROGRESO */}
      <div style={{ padding:"1rem 1.5rem" }}>
        <div style={{ background: cardBg, borderRadius:"12px", padding:"1rem 1.5rem", border:`1px solid ${borde}`, marginBottom:"1rem" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px" }}>
            <span style={{ fontSize:"13px", fontWeight:"600", color: norma.color }}>{normaActiva}</span>
            <span style={{ fontSize:"20px", fontWeight:"700", color: norma.color }}>{calcPorcentaje(normaActiva)}%</span>
          </div>
          <div style={{ height:"8px", background: borde, borderRadius:"4px", overflow:"hidden" }}>
            <div style={{ height:"100%", width:`${calcPorcentaje(normaActiva)}%`, background: norma.color, borderRadius:"4px", transition:"width .5s" }}/>
          </div>
          <div style={{ display:"flex", gap:"12px", marginTop:"8px", flexWrap:"wrap" }}>
            {Object.entries(labelEstado).map(([k,v]) => {
              const count = norma.secciones.reduce((a, s) => a + s.clausulas.filter(c => getEstado(`${normaActiva}-${c.id}`) === k).length, 0);
              return <span key={k} style={{ fontSize:"11px", color: colorEstado[k] }}>{v}: {count}</span>;
            })}
          </div>
        </div>

        {/* SECCIONES Y CLÁUSULAS */}
        {norma.secciones.map(seccion => (
          <div key={seccion.id} style={{ marginBottom:"12px" }}>
            <div style={{ fontSize:"12px", fontWeight:"700", color: norma.color, padding:"6px 0", textTransform:"uppercase", letterSpacing:".08em" }}>{seccion.titulo}</div>
            {seccion.clausulas.map(clausula => {
              const key = `${normaActiva}-${clausula.id}`;
              const d = datos[key];
              const estado = d?.estado || "pendiente";
              const abierta = clausulaAbierta === key;
              return (
                <div key={clausula.id} style={{ background: cardBg, borderRadius:"10px", border:`1.5px solid ${abierta ? norma.color : colorEstado[estado]+"40"}`, marginBottom:"6px", overflow:"hidden" }}>
                  <div onClick={() => { setClausulaAbierta(abierta ? null : key); setForm(d || {}); }}
                    style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 14px", cursor:"pointer" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                      <span style={{ fontSize:"11px", fontWeight:"700", color: norma.color, minWidth:"36px" }}>{clausula.id}</span>
                      <span style={{ fontSize:"13px", color: texto }}>{clausula.titulo}</span>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                      {d?.link && <span style={{ fontSize:"10px", color:"#2A7FFF" }}>🔗</span>}
                      {d?.evidencia && <span style={{ fontSize:"10px", color:"#22c55e" }}>📝</span>}
                      <span style={{ fontSize:"11px", fontWeight:"600", color: colorEstado[estado] }}>{labelEstado[estado]}</span>
                      <span style={{ color: subtexto }}>{abierta ? "▲" : "▼"}</span>
                    </div>
                  </div>

                  {abierta && (
                    <div style={{ padding:"12px 14px", borderTop:`1px solid ${borde}` }}>
                      <span style={lbl}>Estado de cumplimiento</span>
                      <div style={{ display:"flex", gap:"6px", marginTop:"6px", flexWrap:"wrap" }}>
                        {Object.entries(labelEstado).map(([k,v]) => (
                          <button key={k} onClick={() => setForm(f => ({ ...f, estado: k }))}
                            style={{ padding:"5px 10px", borderRadius:"8px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border: form.estado===k ? `2px solid ${colorEstado[k]}` : `1px solid ${borde}`, background: form.estado===k ? `${colorEstado[k]}22` : cardBg, color: form.estado===k ? colorEstado[k] : subtexto }}>
                            {v}
                          </button>
                        ))}
                      </div>

                      <span style={lbl}>Evidencia / descripción</span>
                      <textarea rows={3} value={form.evidencia||""} onChange={e => setForm(f=>({...f,evidencia:e.target.value}))}
                        placeholder="Describí qué evidencia existe para esta cláusula..." style={{...inp, resize:"vertical"}}/>

                      <span style={lbl}>Link al documento (Drive, SharePoint, etc.)</span>
                      <input value={form.link||""} onChange={e => setForm(f=>({...f,link:e.target.value}))} style={inp} placeholder="https://..."/>

                      <span style={lbl}>Responsable</span>
                      <input value={form.responsable||""} onChange={e => setForm(f=>({...f,responsable:e.target.value}))} style={inp} placeholder="Nombre y cargo"/>

                      <span style={lbl}>Fecha de última revisión</span>
                      <input type="date" value={form.fechaRevision||""} onChange={e => setForm(f=>({...f,fechaRevision:e.target.value}))} style={inp}/>

                      <button onClick={() => analizarConARIA(normaActiva, clausula)} disabled={cargandoARIA||!form.evidencia}
                        style={{ marginTop:"10px", padding:"8px 14px", background: cargandoARIA?"#ccc":"linear-gradient(135deg,#7B5BF2,#09184D)", color:"white", border:"none", borderRadius:"8px", cursor: cargandoARIA||!form.evidencia?"default":"pointer", fontSize:"12px", fontWeight:"600" }}>
                        {cargandoARIA ? "🤖 Analizando..." : "🤖 Analizar con ARIA"}
                      </button>

                      {form.ariaJustificacion && (
                        <div style={{ marginTop:"10px", background: oscuro?"#091840":"#f5f3ff", border:"1px solid #7B5BF240", borderRadius:"10px", padding:"12px" }}>
                          <p style={{ fontSize:"12px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 6px" }}>🤖 Análisis ARIA</p>
                          <p style={{ fontSize:"12px", color: texto, margin:"0 0 6px" }}>{form.ariaJustificacion}</p>
                          {form.ariaBrechas?.length > 0 && <>
                            <p style={{ fontSize:"11px", fontWeight:"600", color:"#e63946", margin:"6px 0 2px" }}>Brechas:</p>
                            {form.ariaBrechas.map((b,i) => <p key={i} style={{ fontSize:"11px", color: texto, margin:"1px 0" }}>• {b}</p>)}
                          </>}
                          {form.ariaRecomendaciones?.length > 0 && <>
                            <p style={{ fontSize:"11px", fontWeight:"600", color:"#22c55e", margin:"6px 0 2px" }}>Recomendaciones:</p>
                            {form.ariaRecomendaciones.map((r,i) => <p key={i} style={{ fontSize:"11px", color: texto, margin:"1px 0" }}>• {r}</p>)}
                          </>}
                        </div>
                      )}

                      <div style={{ display:"flex", gap:"8px", marginTop:"12px" }}>
                        <button onClick={() => guardarClausula(normaActiva, clausula.id)}
                          style={{ flex:1, padding:"10px", background: norma.color, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>
                          Guardar
                        </button>
                        <button onClick={() => { setClausulaAbierta(null); setForm({}); }}
                          style={{ padding:"10px 16px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", color: texto, fontSize:"12px" }}>
                          Cancelar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
